import MediumWebPushNotificationsRepository from "~/repositories/Readers/MediumWebPushNotificationsRepository";

declare global {
  interface Window {
    vapidPublicKey: string
  }
}

export const registerMediumServiceworker = () => { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
  if (navigator.serviceWorker) {
    navigator.serviceWorker.register("/serviceworker.js").then(() => {
      navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
        serviceWorkerRegistration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: window.vapidPublicKey
        }).then(async(sub) => {
          await createMediumWebPushNotification(sub);
        }).catch(e => console.log(e));
      }).catch(e => console.log(e));
    }).catch(e => console.log(e));
  } else {
    console.error("Service worker is not supported in this browser");
  }
};

const createMediumWebPushNotification = async(subscription) => {
  try {
    const repository = new MediumWebPushNotificationsRepository();
    const params = {
      mediumWebPushNotification: {
        endpoint: subscription.toJSON().endpoint,
        authKey: subscription.toJSON().keys.auth,
        p256DhKey: subscription.toJSON().keys.p256dh
      }
    };
    await repository.create(params);
  } catch (e) {
    window.alert("通信に失敗しました。再度お試しください。");
    window.webpackBugsnagClient.notify("medium_web_push_notificationの保存に失敗しました。" + JSON.stringify(e, ["message", "arguments", "type", "name"]));
  }
};
